import React from 'react';
import { Navigate } from 'react-router-dom';

// Decode JWT payload client-side (no signature verification — just for routing)
const getJwtPayload = (token) => {
  try {
    const payload = token.split('.')[1];
    const padded  = payload + '='.repeat((4 - payload.length % 4) % 4);
    return JSON.parse(atob(padded));
  } catch { return null; }
};

/**
 * Protects /admin/* routes.
 * Redirects unauthenticated users to /login.
 * Redirects authenticated non-super-admins to /.
 */
const SuperAdminRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  if (!token) return <Navigate to="/login" replace />;

  const payload = getJwtPayload(token);
  if (!payload?.is_super_admin) return <Navigate to="/" replace />;

  return children;
};

export default SuperAdminRoute;
